import BasicContentInfographic from './BasicContentInfographic';

export { type BasicContentInfographicProps } from './BasicContentInfographic';
export default BasicContentInfographic;
